import * as React from 'react';
import 'react-international-phone/style.css';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { useState } from "react";
import parse, { HTMLReactParserOptions, Element } from 'html-react-parser';
import { s3GetUrl } from "../../service/s3Service";
import dayjs from 'dayjs';
import { formatDateTime } from "../../utils/DateUtils";
import { getPoliciesProcedureSignedAttendance, getPoliciesProcedureSignedSignature, postPoliciesProcedureSignedAttendance, postPoliciesProcedureSignedSignature } from '../../service/policiesProcedureSignedSignature';

export default function TaskPoliciesProcedureAttendanceSign(modalProps: any) {

  const id = modalProps?.id;
  const details = modalProps?.details;
  const employeeId = modalProps?.employeeId;
  const toast = React.useRef(null as any);
  console.log('details.employee_id == ', details.employee_id);
  console.log('employeeId == ', employeeId);

  const [document, setDocument] = useState<any>();
  const [employee, setEmployee] = useState<any>();
  const [appointment, setAppointment] = useState<any>();
  const [documentSignature, setDocumentSignature] = useState<any>();
  const [employeeSignature, setEmployeeSignature] = useState<string>();
  const [canSign, setCanSign] = useState<boolean>(false);

  const [html, setHtml] = useState<any>([]);
  const [documentSignaturesClicked, setDocumentSignaturesClicked] = useState<boolean>(false);

  async function sign() {
    modalProps.setGlobalLoading(true);

    try {
      await postPoliciesProcedureSignedAttendance(details.id);
      setTimeout(() => {
        modalProps.toast.current.show({ severity: 'success', summary: 'Signed Successfully', life: 3000 });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      }, 500);
    }
    catch (e) {
      modalProps.toast.current.show({ severity: 'error', summary: 'Failed to Sign Document', life: 3000 });
      modalProps.setGlobalLoading(false);
    }

  }


  function signatureClicked() {
    console.log("details ", details);
    if (details.employee_id !== employeeId && !canSign) {
      toast.current.show({ severity: 'error', summary: 'You are not allowed to sign this document', life: 3000 });
      return;
    }
    if (!employeeSignature) {
      toast.current.show({ severity: 'error', summary: 'Employee has no signature. Set under Employee profile before signing', life: 3000 });
      return;
    }
    if (!documentSignaturesClicked)
      setDocumentSignaturesClicked(true);
  }

  async function fetchData() {
    modalProps.setGlobalLoading(true);
    try {
      console.log(details)
      const resp = await getPoliciesProcedureSignedAttendance(details.id);
      setDocument(resp.template);
      setEmployee(resp.employee);
      setDocumentSignature(resp.document_signature);
      setAppointment(resp.appointment);
      if (resp.employee.signature_s3_key) {
        const s3Url = await s3GetUrl(resp.employee.signature_s3_key);
        setEmployeeSignature(s3Url);
      }
      setCanSign(resp.canSign);
      console.log("resp == ", resp);
    } catch (e) {
      console.log("Error == ", e);
    }
    finally {
      modalProps.setGlobalLoading(false);
    }
  }
  React.useEffect(() => {
    fetchData();
  }, []);



  function renderHtml() {
    if (!document) {
      return;
    }
    setHtml(parse(document.content));
  }

  React.useEffect(() => {
    console.log("React.useEffect => documentSignaturesClicked == ", documentSignaturesClicked);
    renderHtml();
  }, [
    document, documentSignature, employeeSignature, canSign,
    /* Elements dynamically added */
    documentSignaturesClicked
  ]);

  return (
    <React.Fragment>
      {employee && (
        <div style={{ backgroundColor: "#dcdcdc", padding: "20px", borderRadius: "10px", marginBottom: "10px" }}>
          <div>
            <p className="doc-sign-info-item"><span style={{ fontWeight: "bold" }}>Employee</span>: {employee.name} {employee.surname}</p>
            <p className="doc-sign-info-item"><span style={{ fontWeight: "bold" }}>Site</span>: {employee.site_name}</p>
            {appointment?.name && (
              <p className="doc-sign-info-item"><span style={{ fontWeight: "bold" }}>Appointment</span>: {appointment.name}</p>
            )}
            <p className="doc-sign-info-item"><span style={{ fontWeight: "bold" }}>Created At</span>: {formatDateTime(document.created_at)}</p>
          </div>
        </div>
      )}

      <div className="ql-editor">
        {html}
      </div>

      <br/>

      <div
        className="signature-image-container"
        style={{
          height: "80px",
          width: "250px",
          border: "1px dashed #ccc",
          borderRadius: "4px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: documentSignaturesClicked ? "transparent" : "#f5f5f5",
          cursor: !canSign ? "no-drop" : "pointer",//documentSignaturesClicked.includes(currentIndex) ? "default" : "pointer",
          margin: "5px 0"
        }}
        onClick={() => signatureClicked()}
      >
        {documentSignaturesClicked ? (
          <img
            src={employeeSignature}
            alt="Signature"
            style={{ maxWidth: '100%', maxHeight: '100%' }}
          />
        ) : (
          <span>Click to add signature</span>
        )}
      </div>

      <Button type="button" icon="" className="p-button-outlined" size="small"
        label={"Complete Signature"}
        disabled={!documentSignaturesClicked}
        style={{ display: "flex", color: "#2dd36f", marginLeft: "auto" }} onClick={() => sign()} />
      <Toast ref={toast} />
    </React.Fragment>
  );
}